import { useQuery } from "@tanstack/react-query";
import { fetchAllPaymentChannels } from "../repositories/payment.repository";

export const usePaymentChannels = () => {
  return useQuery({
    queryKey: ["paymentChannels"],
    queryFn: fetchAllPaymentChannels,
  });
};
